<template>
    <div class="main">
        <iframe src="mms3D/index.html" ref="mms3d" frameborder="0"></iframe>
        <div class="loding-box" v-show="pagestore">
            <div :class="`title ${istrue ? 'active' : ''}` " @click="pageShow"></div>
            <div class="bgd">
                <div :class="`left ${istrue ? 'active' : ''}` "></div>
                <div :class="`right ${istrue ? 'active' : ''}` "></div>
            </div>
            <div :class="`content ${istrue ? 'active' : ''}` ">
                <div class="bgd1"></div>
                <div class="bgd2"></div>
                <div class="bgd3"></div>
                <div class="bgd4"></div>
                <div class="bgd5"></div>
                <div class="bgd6"></div>
                <div class="bgd7"></div>
                <div class="bgd8"></div>
                <div class="val">{{lodingval}}%</div>
            </div>
        </div>
        <div class="cbgd" v-show="!pagestore">
            <div class="logo"></div>
            <div class="abc">
                <div class="a"></div>
            </div>
            <div class="move1"></div>
            <div class="move2"></div>
            <div class="move3"></div>
        </div>
        <div class="time" v-show="!pagestore">
            <div>{{time.split(' ')[1]}}</div>
            <div>{{time.split(' ')[0]}}</div>
        </div>
        <div class="top-btn-box" v-show="!pagestore">
            <div class="text">工艺流程</div>
            <div :class="`li ${technology == 1 ? 'active' : ''}`" @click="fn1(1)">中底板</div>
            <div :class="`li ${technology == 2 ? 'active' : ''}`" @click="fn1(2)">弯板</div>
            <div :class="`li ${technology == 3 ? 'active' : ''}`" @click="fn1(3)">轨座</div>
            <div :class="`li ${technology == 4 ? 'active' : ''}`" @click="fn1(4)">槽邦</div>
            <div :class="`li ${technology == 5 ? 'active' : ''}`" @click="fn1(5)">中部槽焊接</div>
        </div>
        <div class="left-btn-box" v-show="!pagestore">
            <div class="li">
                <div :class="`btn ${operate == 1? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(1)">
                    <div class="cartoon"></div>
                    <div class="name">全览</div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 2? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(2)">
                    <div class="cartoon"></div>
                    <div class="name">
                        <div class="a">数控</div>
                        <div class="a">切割机</div>
                    </div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 3? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(3)">
                    <div class="cartoon"></div>
                    <div class="name">
                        <div class="a">智能</div>
                        <div class="a">坡口</div>
                    </div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 4? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(4)">
                    <div class="cartoon"></div>
                    <div class="name">
                        <div class="a">智能</div>
                        <div class="a">调质</div>
                    </div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 5? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(5)">
                    <div class="cartoon"></div>
                    <div class="name">喷砂</div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 6? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(6)">
                    <div class="cartoon"></div>
                    <div class="name">
                        <div class="a">智能</div>
                        <div class="a">轨座</div>
                    </div>
                </div>
            </div>
            <div class="li">
                <div :class="`btn ${operate == 7? 'active' : ''} ${technology? 'no' : ''} `" @click="fn2(7)">
                    <div class="cartoon"></div>
                    <div class="name">
                        <div class="a">中部槽</div>
                        <div class="a">流水线</div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="`right-box ${cartoon ? 'active' : ''}`" v-show="!pagestore">
            <div class="model model1">
                <div class="title-box">
                    <div class="a">生产订单/工单报表</div>
                    <div class="b">/</div>
                    <div class="c">Orders/Reports</div>
                </div>
                <div class="btn-box">
                    <div :class="  {btn:true,active:pageData.data1Show==0}" @click="dataBtnFn('data1',0)">
                        <span>生产订单</span>
                    </div>
                    <div :class="  {btn:true,active:pageData.data1Show==1}" @click="dataBtnFn('data1',1)">
                        <span>工单报表</span>
                    </div>
                </div>
                <div class="info">
                    <div class="li">
                        <div class="icon"></div>
                        <div class="val-box">
                            <div class="val">
                                <div class="a" v-for="item,i in dataHandleFn(pageData.data1[pageData.data1Show].num)" :key="i">
                                    <span>{{item}}</span>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="name">{{pageData.data1[pageData.data1Show].numName}}</div>
                        </div>
                    </div>
                    <div class="li">
                        <div class="icon"></div>
                        <div class="val-box">
                            <div class="val">
                                <div class="a" v-for="item,i in dataHandleFn(pageData.data1[pageData.data1Show].okNum)" :key="i">
                                    <span>{{item}}</span>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="name">{{pageData.data1[pageData.data1Show].okNumName}}</div>
                        </div>
                    </div>
                </div>
                <div class="tab">
                    <div class="tab-title">{{pageData.data1[pageData.data1Show].tab.name}}</div>
                    <div class="tab-content">
                        <div class="thead">
                            <div class="th" v-for="item,i in pageData.data1[pageData.data1Show].tab.thead" :key="i">
                                <span>{{item}}</span>
                            </div>
                        </div>
                        <div class="tbody" ref="scroll1" @mouseover="stopScrollFn(1)" @mouseout="scrollFn(1)">
                            <div class="tr" v-for="item,i in pageData.data1[pageData.data1Show].tab.tbody" :key="i">
                                <div class="td">
                                    <span>{{item.id}}</span>
                                </div>
                                <div class="td">
                                    <span>{{item.name}}</span>
                                </div>
                                <div class="td" v-if="pageData.data1Show==0">
                                    <span>{{item.time}}</span>
                                </div>
                                <div class="td" v-if="pageData.data1Show==1">
                                    <span>{{item.type}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="model model2">
                <div class="title-box">
                    <div class="a">人员情况</div>
                    <div class="b">/</div>
                    <div class="c">Personnel situation</div>
                    <div class="d">{{pageData.data2.name}}</div>
                </div>
                <div class="tab">
                    <div class="thead">
                        <div class="th1" v-for="item,i in pageData.data2.thead" :key="i">
                            <span>{{item}}</span>
                        </div>
                    </div>
                    <div class="tbody" ref="scroll2" @mouseover="stopScrollFn(2)" @mouseout="scrollFn(2)">
                        <div class="tr" v-for="item,i in pageData.data2.tbody" :key="i">
                            <div class="td1">
                                <span>{{item.position}}</span>
                            </div>
                            <div class="td2">
                                <span>{{item.name}}</span>
                            </div>
                            <div class="td3">
                                <span>{{item.type}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="model model3">
                <div class="title-box">
                    <div class="a">能耗统计分析</div>
                    <div class="b">/</div>
                    <div class="c">Energy consumption statistics</div>
                </div>
                <div class="content">
                    <div class="btn-box">
                        <div :class="{btn:true,active:pageData.data3Show == 0}" @click="dataBtnFn('data3',0)">月</div>
                        <div :class="{btn:true,active:pageData.data3Show == 1}" @click="dataBtnFn('data3',1)">季</div>
                        <div :class="{btn:true,active:pageData.data3Show == 2}" @click="dataBtnFn('data3',2)">年</div>
                    </div>
                    <div class="echarts-box">
                        <VueEcharts :option='option' autosize ref="echarts1" style="width:300px;flex:1" />
                    </div>
                </div>
            </div>
            <div class="model model4">
                <div class="title-box">
                    <div class="a">质量报表</div>
                    <div class="b">/</div>
                    <div class="c">Quality reports</div>
                </div>
                <div class="content">
                    <div class="echarts-box">
                        <VueEcharts :option='option2' ref="echarts2" />
                    </div>
                    <div class="btn-box">
                        <div class="a">
                            <span>【</span>
                        </div>
                        <div :class="{name:true,active:pageData.data4Show == 0}" @click="dataBtnFn('data4',0)">日</div>
                        <div :class="{name:true,active:pageData.data4Show == 1}" @click="dataBtnFn('data4',1)">月</div>
                        <div :class="{name:true,active:pageData.data4Show == 2}" @click="dataBtnFn('data4',2)">季</div>
                        <div :class="{name:true,active:pageData.data4Show == 3}" @click="dataBtnFn('data4',3)">年</div>
                        <div class="b">
                            <span>】</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="`bottom-box ${cartoon ? 'active' : ''}`" v-show="!pagestore">
            <div class="model1">
                <div class="title-box">
                    <div class="a">物料使用情况报表</div>
                    <div class="b">/</div>
                    <div class="c">Item usage reports</div>
                </div>
                <div class="content">
                    <table cellspacing='0' cellpadding='0'>
                        <tr class="tr1">
                            <td>&nbsp;</td>
                            <td colspan=3 align="center" valign="middle">
                                <span>领料</span>
                            </td>
                            <td colspan=3 align="center" valign="middle">
                                <span>耗用</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>结存</span>
                            </td>
                            <td colspan=3 align="center" valign="middle">
                                <span>领入累计</span>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" valign="middle">
                                <span>名称</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>本日领入</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>昨日结存</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>合计</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>本日耗用</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>损坏</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>合计</span>
                            </td>
                            <td>&nbsp;</td>
                            <td align="center" valign="middle">
                                <span>本月领入</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>上月结存</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>合计</span>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" valign="middle">
                                <span>板材</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>10</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>10</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>20</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>10</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>5</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>15</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>5</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>100</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>120</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>220</span>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" valign="middle">
                                <span>轨座</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>20</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>10</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>30</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>25</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>5</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>30</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>0</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>120</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>80</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>200</span>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" valign="middle">
                                <span>槽邦</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>15</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>15</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>30</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>10</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>6</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>16</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>14</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>120</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>120</span>
                            </td>
                            <td align="center" valign="middle">
                                <span>240</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="model2">
                <div class="title-box">
                    <div class="a">设备维修情况</div>
                    <div class="b">/</div>
                    <div class="c">Equipment repair</div>
                    <div class="btn-box">
                        <div :class="{btn:true,active: pageData.data6Show[0] == 0}" @click="dataBtnFn('data6',[0,0])">本月</div>
                        <div :class="{btn:true,active: pageData.data6Show[0] == 1}" @click="dataBtnFn('data6',[0,1])">本年</div>
                    </div>
                </div>
                <div class="content">
                    <div class="btn-box">
                        <div :class="{btn:true,active:pageData.data6Show[1] == 0}" @click="dataBtnFn('data6',[1,0])">维修计划</div>
                        <div :class="{btn:true,active:pageData.data6Show[1] == 1}" @click="dataBtnFn('data6',[1,1])">维修统计分析</div>
                    </div>
                    <VueEcharts :option='option4' autosize ref="echarts4" style="width:297px;flex:1" v-if="pageData.data6Show[1] == 1" />
                    <div class="info-box" v-if="pageData.data6Show[1] == 0">
                        <div class="box">
                            <div class="info">
                                <div class="icon icon1"></div>
                                <div class="val-box">
                                    <div class="val">
                                        <span>{{ pageData.data6[pageData.data6Show[0]].planInfo.plan }}</span>
                                        <span>/个</span>
                                    </div>
                                    <div class="name">计划</div>
                                </div>
                            </div>
                            <div class="info">
                                <div class="icon icon2"></div>
                                <div class="val-box">
                                    <div class="val">
                                        <span>{{ pageData.data6[pageData.data6Show[0]].planInfo.ok }}</span>
                                        <span>/个</span>
                                    </div>
                                    <div class="name">已完成</div>
                                </div>
                            </div>
                        </div>
                        <div class="box">
                            <div class="info">
                                <div class="icon icon3"></div>
                                <div class="val-box">
                                    <div class="val">
                                        <span>{{ pageData.data6[pageData.data6Show[0]].planInfo.notStart }}</span>
                                        <span>/个</span>
                                    </div>
                                    <div class="name">未开始</div>
                                </div>
                            </div>
                            <div class="info">
                                <div class="icon icon4"></div>
                                <div class="val-box">
                                    <div class="val">
                                        <span>{{ pageData.data6[pageData.data6Show[0]].planInfo.underRepair }}</span>
                                        <span>/个</span>
                                    </div>
                                    <div class="name">维修中</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="model3">
                <div class="title-box">
                    <div class="a">设备点检统计分析</div>
                    <div class="b">/</div>
                    <div class="c">Equipment spot check</div>
                </div>
                <div class="content">
                    <div class="icon"></div>
                    <div class="info">
                        <div class="li">
                            <div class="a a1"></div>
                            <div class="name">点检维修:</div>
                            <div class="val">{{pageData.data7.maintain}}%</div>
                        </div>
                        <div class="li">
                            <div class="a a2"></div>
                            <div class="name">超期未点检:</div>
                            <div class="val">{{pageData.data7.notChecked}}%</div>
                        </div>
                        <div class="li">
                            <div class="a a3"></div>
                            <div class="name">点检正常:</div>
                            <div class="val">{{pageData.data7.normal}}%</div>
                        </div>
                        <div class="li">
                            <div class="a a4"></div>
                            <div class="name">点检异常:</div>
                            <div class="val">{{pageData.data7.unusual}}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="model4">
                <div class="title-box">
                    <div class="a">设备状态统计</div>
                    <div class="b">/</div>
                    <div class="c">Device status statistics</div>
                </div>
                <div class="echarts-box">
                    <VueEcharts :option='option3' ref="echarts3" />
                </div>
            </div>
            <div class="model5">
                <div class="title-box">
                    <div class="a">设备报警信息</div>
                    <div class="b">/</div>
                    <div class="c">Device alarm information</div>
                </div>
                <div class="content">

                    <div class="tab">
                        <div class="thead">
                            <div class="th" v-for="item,i in pageData.data9.thead" :key="i">
                                <span>{{item}}</span>
                            </div>
                        </div>
                        <div class="tbody" ref="scroll3" @mouseover="stopScrollFn(3)" @mouseout="scrollFn(3)">
                            <div class="tr" v-for="item,i in pageData.data9.tbody" :key="i">
                                <div class="td">
                                    <span>{{item.time}}</span>
                                </div>
                                <div class="td">
                                    <span>{{item.name}}</span>
                                </div>
                                <div class="td">
                                    <span>{{item.type}}</span>
                                </div>
                                <div class="td">
                                    <span>{{item.isHandle}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue'
import moment from 'moment'
import VueEcharts from "vue-echarts";
import * as echarts from 'echarts';
const time = ref('0000-00-00 00:00:00')
const istrue = ref(false)
const pagestore = ref(true)
const echarts1 = ref(null)
const echarts2 = ref(null)
const echarts3 = ref(null)
const echarts4 = ref(null)
// 工艺流程的状态 1、2、3、4、5
const technology = ref(0)
const lodingval = ref(0)
const mms3d = ref(null)
// 

const operate = ref(1)
// 2维页面进入动画
const cartoon = ref(false)
let timer1 = null
let timer2 = null
let timer3 = null
let timer4 = null
const btn2 = ref([1, 1])
const pageData = ref({
    data1Show: 0,
    data1: [
        {
            name: '生产订单',
            num: 50,
            okNum: 10,
            numName: '本月订单数量',
            okNumName: '本月完成',
            tab: {
                name: '产品订单详情',
                thead: ['生产令号', '名称', '计划完成日期'],
                tbody: [
                    {
                        id: 'AC21420',
                        name: '数控切割机',
                        time: '2023/03/10'
                    },
                    {
                        id: 'AC21421',
                        name: '智能坡口',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21422',
                        name: '智能调质',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21423',
                        name: '喷砂',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21424',
                        name: '智能轨座',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21425',
                        name: '中部流水线',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21426',
                        name: '数控切割机',
                        time: '2023/03/10'
                    },
                    {
                        id: 'AC21427',
                        name: '智能坡口',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21428',
                        name: '智能调质',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21429',
                        name: '喷砂',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21430',
                        name: '智能轨座',
                        time: '2023/03/12'
                    },
                    {
                        id: 'AC21431',
                        name: '中部流水线',
                        time: '2023/03/12'
                    },
                ]

            }

        },
        {
            name: '工单报表',
            num: 50,
            okNum: 100,
            numName: '本日工单数量',
            okNumName: '本日完成',
            tab: {
                name: '本日工单详情',
                thead: ['工单号', '名称', '状态'],
                tbody: [
                    {
                        id: 'AC21420',
                        name: '数控切割机',
                        type: '完成'
                    },
                    {
                        id: 'AC21421',
                        name: '智能坡口',
                        type: '未完成'
                    },
                    {
                        id: 'AC21422',
                        name: '智能调质',
                        type: '正在生产'
                    },
                    {
                        id: 'AC21423',
                        name: '喷砂',
                        type: '完成'
                    },
                    {
                        id: 'AC21424',
                        name: '智能轨座',
                        type: '未完成'
                    },
                    {
                        id: 'AC21425',
                        name: '中部流水线',
                        type: '正在生产'
                    },
                    {
                        id: 'AC21426',
                        name: '数控切割机',
                        type: '完成'
                    },
                    {
                        id: 'AC21427',
                        name: '智能坡口',
                        type: '未完成'
                    },
                    {
                        id: 'AC21428',
                        name: '智能调质',
                        type: '正在生产'
                    },
                    {
                        id: 'AC21429',
                        name: '喷砂',
                        type: '完成'
                    },
                    {
                        id: 'AC21430',
                        name: '智能轨座',
                        type: '未完成'
                    },
                    {
                        id: 'AC21431',
                        name: '中部流水线',
                        type: '正在生产'
                    }
                ]
            }

        }
    ],
    data2: {
        name: '甲班组',
        thead: ['工位', '人员', '状态'],
        tbody: [
            {
                position: '板材切割',
                name: '孙晓',
                type: '开工'
            },
            {
                position: '坡口',
                name: '雷磊',
                type: '开工'
            },
            {
                position: '调质',
                name: '李坤',
                type: '未开工'
            },
            {
                position: '喷砂',
                name: '米苏',
                type: '开工'
            },
            {
                position: '轨座',
                name: '赵小熠',
                type: '未开工'
            },
            {
                position: '中部槽流水线',
                name: '黄姚',
                type: '开工'
            },
            {
                position: '板材切割',
                name: '钱多多',
                type: '未开工'
            },
            {
                position: '坡口',
                name: '玖玥',
                type: '开工'
            },
            {
                position: '调质',
                name: '李洲',
                type: '开工'
            },
            {
                position: '喷砂',
                name: '李杭',
                type: '未开工'
            },
            {
                position: '轨座',
                name: '周昭',
                type: '开工'
            },
            {
                position: '中部槽流水线',
                name: '周一帆',
                type: '未开工'
            },
            {
                position: '调质',
                name: '龚法',
                type: '开工'
            },
            {
                position: '板材切割',
                name: '王翼',
                type: '未开工'
            }
        ]
    },
    data3Show: 0,
    data3: [
        {
            name: '月',
            x: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            y: [
                [450, 280, 320, 400, 380, 350, 300, 320, 400],
                [350, 320, 330, 380, 430, 400, 300, 350, 400],
                [320, 280, 290, 330, 350, 300, 220, 290, 320]
            ]
        },
        {
            name: '季',
            x: ['春', '夏', '秋', '冬'],
            y: [
                [650, 580, 520, 600],
                [550, 520, 430, 580],
                [620, 580, 490, 630]
            ]
        },
        {
            name: '年',
            x: [2020, 2021, 2022, 2023],
            y: [
                [1350, 1300, 1320, 1400],
                [1400, 1300, 1350, 1400],
                [1300, 1220, 1290, 1320]
            ]
        }
    ],
    data4Show: 0,
    data4: [
        {
            name: '日',
            info: [
                {
                    name: '合格率',
                    val: 86
                },
                {
                    name: '良品数',
                    val: 225
                },
                {
                    name: '不良品数',
                    val: 32
                },
                {
                    name: '报废',
                    val: 2
                },
                {
                    name: '返修',
                    val: 15
                }
            ]
        },
        {
            name: '月',
            info: [
                {
                    name: '合格率',
                    val: 80
                },
                {
                    name: '良品数',
                    val: 220
                },
                {
                    name: '不良品数',
                    val: 31
                },
                {
                    name: '报废',
                    val: 5
                },
                {
                    name: '返修',
                    val: 15
                }
            ]
        },
        {
            name: '季',
            info: [
                {
                    name: '合格率',
                    val: 90
                },
                {
                    name: '良品数',
                    val: 230
                },
                {
                    name: '不良品数',
                    val: 32
                },
                {
                    name: '报废',
                    val: 2
                },
                {
                    name: '返修',
                    val: 15
                }
            ]
        },
        {
            name: '年',
            info: [
                {
                    name: '合格率',
                    val: 70
                },
                {
                    name: '良品数',
                    val: 200
                },
                {
                    name: '不良品数',
                    val: 32
                },
                {
                    name: '报废',
                    val: 2
                },
                {
                    name: '返修',
                    val: 15
                }
            ]
        }
    ],
    data5: {},
    data6Show: [0, 0],
    data6: [
        {
            name: '本月',
            // 计划
            planInfo: {
                plan: 21,
                ok: 10,
                notStart: 3,
                underRepair: 8
            },
            // 分析
            analyse: {
                x: [1, 2, 3, 4, 5, 6],
                data: [
                    [300, 200, 250, 320, 330, 400],
                    [400, 200, 320, 220, 250, 200],
                    [250, 320, 330, 420, 330, 350]
                ]
            }
        },
        {
            name: '本年',
            // 计划
            planInfo: {
                plan: 19,
                ok: 12,
                notStart: 3,
                underRepair: 5
            },
            // 分析
            analyse: {
                x: [1, 2, 3, 4, 5, 6],
                data: [
                    [700, 520, 250, 620, 930, 700],
                    [900, 520, 250, 620, 930, 750],
                    [500, 520, 320, 420, 630, 900]
                ]
            }
        }
    ],
    data7: {
        // 维修  %
        maintain: 2.06,
        // 未点检 %
        notChecked: 1.02,
        // 正常 %
        normal: 96,
        // 异常 %
        unusual: 0.5
    },
    data8: {
        // 总数 
        total: 55,
        // 停机
        halt: 5,
        // 正常
        normal: 45,
        // 故障
        hitch: 2
    },
    data9: {
        thead: ['日期', '名称', '报警类型', '处理情况'],
        tbody: [
            {
                time: '2022.8.26',
                name: '压力机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.26',
                name: '切割机',
                type: '异常',
                isHandle: '已处理'
            },
            {
                time: '2022.8.26',
                name: '喷砂机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.26',
                name: '切割机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.26',
                name: '智能轨座',
                type: '异常',
                isHandle: '已处理'
            },
            {
                time: '2022.8.26',
                name: '切割机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.25',
                name: '压力机',
                type: '异常',
                isHandle: '已处理'
            },
            {
                time: '2022.8.25',
                name: '切割机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.25',
                name: '喷砂机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.25',
                name: '切割机',
                type: '异常',
                isHandle: '未处理'
            },
            {
                time: '2022.8.24',
                name: '智能轨座',
                type: '异常',
                isHandle: '已处理'
            },
            {
                time: '2022.8.24',
                name: '切割机',
                type: '异常',
                isHandle: '未处理'
            }
        ]
    }
})
const option = ref({
    // backgroundColor: '#2C313E',
    legend: {
        icon: 'rect',
        top: 1,
        left: 'center',
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 60,
        textStyle: {
            color: '#fff',
            fontSize: 8
        },
    },
    tooltip: {
        trigger: 'axis',
    },
    grid: {
        top: '17%',
        left: '1%',
        right: '3%',
        bottom: '0%',
        containLabel: true,
    },
    xAxis: [
        {
            type: 'category',
            data: pageData.value.data3[pageData.value.data3Show].x,
            axisLine: {
                show: true,

            },
            axisLabel: {
                textStyle: {
                    color: '#fff',//左侧数标
                    fontSize: 8
                },
            },
            boundaryGap: false,
            axisTick: {
                //坐标轴刻度相关设置。
                show: false,
            },
        },
    ],
    yAxis: [
        {
            type: 'value',
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,

            },
            axisLabel: {
                textStyle: {
                    color: '#fff',//左侧数标
                    fontSize: 8
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#ff0000',
                    type: 'dashed',
                    opacity: 0.1,
                },
            },
        },
        {
            type: 'value',
            position: 'right',
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: false,
                textStyle: {
                    color: '#666', //右侧数标
                },
                formatter: '{value}',
            },
            axisLine: {
                show: false,
            },
            splitLine: {
                show: false,
            },
        },
    ],
    series: [
        {
            name: '水',
            type: 'line',
            data: [450, 280, 320, 400, 380, 350, 300, 320, 400],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#00bbff', //绿线颜色
            },
            itemStyle: {
                normal: {
                    color: 'rgba(0, 187, 255, 1)', //绿线渐变颜色
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                            {
                                offset: 0,
                                color: 'rgba(0, 187, 255, 0)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(0, 187, 255, 1)',
                            },
                        ]),
                    },
                },
            },
        },
        {
            name: '电',
            type: 'line',
            data: [350, 320, 330, 380, 430, 400, 300, 350, 400],
            symbolSize: 1,
            yAxisIndex: 1,
            symbol: 'circle',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#00ffea',//黄线颜色
            },
            itemStyle: {
                normal: {
                    color: 'rgba(0, 255, 234, 1)',
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                            {
                                offset: 0,
                                color: 'rgba(0, 255, 234, 0)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(0, 255, 234, 1)',
                            },
                        ]),
                    },
                },
            },
        },
        {
            name: '气',
            type: 'line',
            data: [320, 280, 290, 330, 350, 300, 220, 290, 320],
            symbolSize: 1,
            yAxisIndex: 1,
            symbol: 'circle',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#ffc000',//黄线颜色
            },
            itemStyle: {
                normal: {
                    color: 'rgba(255, 192, 0, 1)',
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                            {
                                offset: 0,
                                color: 'rgba(255, 192, 0, 0)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(255, 192, 0, 1)',
                            },
                        ]),
                    },
                },
            },
        },
    ],
})


const option2 = ref({
    // backgroundColor: '#0A2E5D',
    "normal": {
        "top": 200,
        "left": 300,
        "width": 500,
        "height": 400,
        "zIndex": 6,
        "backgroundColor": ""
    },
    "radar": {
        "center": ["50%", "50%"],
        "radius": "67%",
        "startAngle": -10,
        "splitNumber": 4,
        "shape": "circle",
        "splitArea": {
            "areaStyle": {
                "color": ["#2380ff50"]
            }
        },
        "axisLabel": {
            "show": false,
            "fontSize": 18,
            "color": "#fff",
            "fontStyle": "normal",
            "fontWeight": "normal"
        },
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "#cccccc50"//
            }
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": "#cccccc50"//
            }
        },
        name: {
            textStyle: {
                color: "rgba(250,250,250,1)",
                fontSize: 10,
                rich: {
                    a: {
                        color: '#fff',
                        fontSize: 10,
                        padding: [0,
                            0,
                            0,
                            0],
                    },
                    b: {
                        color: '#03b4f4',
                        fontSize: 10,
                        padding: [0,
                            0,
                            0,
                            0],
                    },
                },
            },
            formatter: function (value, obj) {
                return '{a|' + value + '}\n' + '{b|' + obj.value + obj.unit + '}'
            }
        },
        "indicator": [{
            "name": "良品数",
            "min": 0,
            "value": 225,
            "unit": '台'
        }, {
            "name": "合格率",
            "max": 100,
            "value": 86,
            "unit": '%'
        }, {
            "name": "返修",
            "max": 100,
            "value": 15,
            "unit": '台'
        }, {
            "name": "报废",
            "max": 10,
            "value": 2,
            "unit": '台'
        }, {
            "name": "不良品数",
            "max": 100,
            "value": 32,
            "unit": '台'
        }
        ]
    },
    "series": [{
        "name": "质量报表",
        "type": "radar",
        "symbol": "circle",
        "symbolSize": 10,
        "itemStyle": {
            "normal": {
                color: 'rgba(19, 173, 255, 0)',
                "borderColor": "rgba(19, 173, 255, 0.4)",
                "borderWidth": 0
            }
        },
        "areaStyle": {
            "normal": {
                "color": "rgba(19, 173, 255, 0.5)"
            }
        },
        "lineStyle": {
            "normal": {
                "color": "rgba(19, 173, 255, 1)",
                "width": 2,
                "type": "solid"
            }
        },
        "data": [
            [225, 86, 15, 2, 32]
        ]
    }]
});
const option3 = {
    graphic: {
        elements: [{
            type: "image",
            z: 3,
            style: {
                image: "data:image/png;base64,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",
                width: 74,
                height: 74
            },
            left: 'center',
            top: 'center',
        }]
    },
    series: [{
        name: '',
        type: 'pie',
        radius: ['55%', '75%'],
        avoidLabelOverlap: false,
        label: {
            show: true,
            formatter: (obj) => {
                if (obj.data.value2) {
                    return obj.name + ': ' + obj.data.value2 + '台'
                }

            }

        },
        startAngle: 88,
        emphasis: {
            label: {
                show: true,
            }
        },
        // labelLine: {
        //   show: true
        // },
        select: {
            show: true,
            label: {
                show: true,
            }
        },
        data: [{
            value: 23,
            name: '停机',
            value2: pageData.value.data8.halt,
            itemStyle: {
                color: '#17aead'
            },
            label: {
                color: '#17aead'
            }
        },
        {
            value: 1,
            name: '',
            itemStyle: {
                color: '#ffffff00'
            },
        },
        {
            value: 23,
            name: '故障',
            value2: pageData.value.data8.hitch,
            itemStyle: {
                color: '#ffbd18'
            },
            label: {
                color: '#ffbd18'
            }
        },
        {
            value: 1,
            name: '',
            itemStyle: {
                color: '#ffffff00'
            },

        },
        {
            value: 23,
            name: '正常',
            value2: pageData.value.data8.normal,
            itemStyle: {
                color: '#ccc'
            },
            label: {
                color: '#ccc'
            }
        },
        {
            value: 1,
            name: '',
            itemStyle: {
                color: '#ffffff00'
            }
        },
        {
            value: 23,
            name: '总数',
            value2: pageData.value.data8.total,
            itemStyle: {
                color: '#00bbff'
            },
            label: {
                color: '#00bbff'
            }
        },
        {
            value: 1,
            name: '',
            itemStyle: {
                color: '#ffffff00'
            }
        },
        ]
    }]
};
const option4 = ref({
    // backgroundColor: '#2C313E',
    legend: {
        icon: 'rect',
        top: 5,
        left: 'center',
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 60,
        textStyle: {
            color: '#fff',
            fontSize: 10
        },
    },
    tooltip: {
        trigger: 'axis',
    },
    grid: {
        top: '23%',
        left: '1%',
        right: '3%',
        bottom: '0%',
        containLabel: true,
    },
    xAxis: [
        {
            type: 'category',
            data: pageData.value.data6[pageData.value.data6Show[0]].analyse.x,
            axisLine: {
                show: true,

            },
            axisLabel: {
                textStyle: {
                    color: '#fff',//左侧数标
                    fontSize: 8
                },
            },
            boundaryGap: false,
            axisTick: {
                //坐标轴刻度相关设置。
                show: false,
            },
        },
    ],
    yAxis: [
        {
            type: 'value',
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,

            },
            axisLabel: {
                textStyle: {
                    color: '#fff',//左侧数标
                    fontSize: 8
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#ff0000',
                    type: 'dashed',
                    opacity: 0.1,
                },
            },
        },
        {
            type: 'value',
            position: 'right',
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: false,
                textStyle: {
                    color: '#666', //右侧数标
                },
                formatter: '{value}',
            },
            axisLine: {
                show: false,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#6e7079', //右侧数标
                },
            },
        },
    ],
    series: [
        {
            name: '未开始',
            type: 'line',
            data: pageData.value.data6[pageData.value.data6Show[0]].analyse.data[0],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#00bbff', //绿线颜色
            },
        },
        {
            name: '已完成',
            type: 'line',
            data: pageData.value.data6[pageData.value.data6Show[0]].analyse.data[1],
            symbolSize: 1,
            yAxisIndex: 1,
            symbol: 'circle',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#00ffea',//黄线颜色
            },
        },
        {
            name: '维修中',
            type: 'line',
            data: pageData.value.data6[pageData.value.data6Show[0]].analyse.data[2],
            symbolSize: 1,
            yAxisIndex: 1,
            symbol: 'circle',
            smooth: true,
            showSymbol: false,
            lineStyle: {
                width: 2,
                color: '#ffc000',//黄线颜色
            },
        },
    ],
})

// const option3 = {
//     series: [{
//         type: "pie",
//         hoverAnimation: false,
//         center: ['50%', '50%'],
//         radius: ["43%", "70%"],
//         color: ['#1ab0b0', '#ffc000', '#fff', '#00bbff'],
//         // startAngle: 135,
//         labelLine: {
//             padding: [20, 20],
//             normal: {
//                 // length:20 * scale,
//                 length: 0,
//                 length2: 120,
//                 lineStyle: {
//                     color: '#fff'
//                 }
//             }
//         },
//         label: {
//             normal: {
//                 formatter: function (params) {
//                     console.log(params);
//                     return params.name + ': ' + params.data.value2

//                 },
//                 padding: [0, -70],
//                 height: 20,
//                 color:'#fff'
//             },

//         },
//         data: [
//             {
//                 name: '停机',
//                 value: 25,
//                 value2: "52台",
//             },
//             {
//                 name: '故障',
//                 value: 25,
//                 value2: "52台",
//             },
//             {
//                 name: '正常',
//                 value: 25,
//                 value2: "52台",
//             },
//             {
//                 name: '总数',
//                 value: 25,
//                 value2: "52台",
//             },
//         ]
//     }]
// }
const echarts2Height = ref(0)
const scroll1 = ref(null)
const scroll2 = ref(null)
const scroll3 = ref(null)
function pageShow() {
    istrue.value = true
    setTimeout(() => {
        pagestore.value = false
    }, 1000);

}
// 2dinfo进入
function modelto() {
    cartoon.value = true
    echarts2.value.resize()
    echarts1.value.resize()
    echarts3.value.resize()
    // echarts4.value.resize()
}
function lodingVal(i) {
    lodingval.value = i
}
function fn1(i) {
    if (technology.value == i) {
        technology.value = 0
        mms3d.value.contentWindow.MMAPI.processAnimation(i, false)
        fn2(1)
    } else {
        if (operate.value !== 1) {
            fn2(1)
        }
        technology.value = i
        mms3d.value.contentWindow.MMAPI.processAnimation(i, true)
    }

}
function fn2(i) {
    if (technology.value) {
        return
    }
    operate.value = i
    mms3d.value.contentWindow.MMAPI.cameraTargetPotion(i)
    mms3d.value.contentWindow.MMAPI.ioticon(i)
}
function dataBtnFn(name, i) {
    switch (name) {
        case 'data1':
            pageData.value.data1Show = i
            break;
        case 'data3':
            pageData.value.data3Show = i
            option.value.xAxis[0].data = pageData.value.data3[pageData.value.data3Show].x
            option.value.series[0].data = pageData.value.data3[pageData.value.data3Show].y[0]
            option.value.series[1].data = pageData.value.data3[pageData.value.data3Show].y[1]
            option.value.series[2].data = pageData.value.data3[pageData.value.data3Show].y[2]
            break;
        case 'data4':
            pageData.value.data4Show = i
            let a = pageData.value.data4[pageData.value.data4Show].info[1].val
            let b = pageData.value.data4[pageData.value.data4Show].info[0].val
            let c = pageData.value.data4[pageData.value.data4Show].info[4].val
            let d = pageData.value.data4[pageData.value.data4Show].info[3].val
            let e = pageData.value.data4[pageData.value.data4Show].info[2].val
            option2.value.radar.indicator[0].value = a
            option2.value.radar.indicator[1].value = b
            option2.value.radar.indicator[2].value = c
            option2.value.radar.indicator[3].value = d
            option2.value.radar.indicator[4].value = e
            option2.value.series[0].data[0] = [a, b, c, d, e]
            break;
        case 'data6':
            pageData.value.data6Show[i[0]] = i[1]
            if (pageData.value.data6Show[1] == 1) {
                option4.value.xAxis[0].data = pageData.value.data6[pageData.value.data6Show[0]].analyse.x
                option4.value.series[0].data = pageData.value.data6[pageData.value.data6Show[0]].analyse.data[0]
                option4.value.series[1].data = pageData.value.data6[pageData.value.data6Show[0]].analyse.data[1]
                option4.value.series[2].data = pageData.value.data6[pageData.value.data6Show[0]].analyse.data[2]
            }
            break;

        default:
            break;
    }
}
function btn2Fn(a, i) {
    // a那层  i值
    btn2.value[a - 1] = i
}
function dataHandleFn(val) {
    let newVal = val + ''
    switch (newVal.length) {
        case 1:
            return '000' + val
        case 2:
            return '00' + val
        case 3:
            return '0' + val
        case 4:
            return val
        default:
            return '0000'
    }
}
function scrollFn(i) {
    switch (i) {
        case 1:
            stopScrollFn(i)
            timer2 = setInterval(() => {
                if (scroll1.value.scrollHeight == scroll1.value.scrollTop + scroll1.value.offsetHeight) {
                    scroll1.value.scrollTop = 0
                } else {
                    scroll1.value.scrollTop++;
                }
            }, 50);
            break;
        case 2:
            stopScrollFn(i)
            timer3 = setInterval(() => {
                if (scroll2.value.scrollHeight == scroll2.value.scrollTop + scroll2.value.offsetHeight) {
                    scroll2.value.scrollTop = 0
                } else {
                    scroll2.value.scrollTop++;
                }
            }, 50);
            break;
        case 3:
            stopScrollFn(i)
            timer4 = setInterval(() => {
                if (scroll3.value.scrollHeight == scroll3.value.scrollTop + scroll3.value.offsetHeight) {
                    scroll3.value.scrollTop = 0
                } else {
                    scroll3.value.scrollTop++;
                }
            }, 50);
            break;
        default:
            break;
    }

}
function stopScrollFn(i) {
    switch (i) {
        case 1:
            clearInterval(timer2);
            timer2 = null;
            break;
        case 2:
            clearInterval(timer3);
            timer3 = null;
            break;
        case 3:
            clearInterval(timer4);
            timer4 = null;
            break;
        default:
            break;
    }
}
onMounted(() => {
    window.pageShow = pageShow
    window.lodingVal = lodingVal
    window.modelto = modelto
    window.fn1 = fn1
    time.value = moment().format('YYYY-MM-DD HH:mm:ss')
    timer1 = setInterval(() => {
        time.value = moment().format('YYYY-MM-DD HH:mm:ss')
    }, 1000);
    scrollFn(1)
    scrollFn(2)
    scrollFn(3)
    window.onresize = function () {
        echarts2.value.resize()
        echarts3.value.resize()
        // echarts2Height.value = echarts2.value.clientHeight
    }
})
onBeforeUnmount(() => {
    clearInterval(timer1);
    clearInterval(timer2);
    timer1 = null;
    timer2 = null;

})
</script>

<style lang='less' scoped>
.main {
    overflow: hidden;
    position: relative;
}
.loding-box {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    z-index: 1;
    .title {
        width: 100%;
        height: 69px;
        background: url("@/assets/img/title.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        z-index: 1;
        top: 0;
        transition: opacity 2s;
    }
    .title.active {
        opacity: 0;
    }
    .bgd {
        width: 100%;
        height: 100%;
        display: flex;
        .left {
            flex: 1;
            height: 100%;
            background: url("@/assets/img/loding-bgd1.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            transition: transform 2s, opacity 2s;
        }
        .left.active {
            transform: translate(-100%, 0);
            opacity: 0;
        }

        .right {
            flex: 1;
            height: 100%;
            background: url("@/assets/img/loding-bgd2.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            transition: transform 2s, opacity 2s;
        }
        .right.active {
            transform: translate(100%, 0);
            opacity: 0;
        }
    }
    .content {
        width: 34vw;
        height: 34vw;
        background: url("@/assets/img/loding-bgd3.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: calc(50% - 17vw);
        left: calc(50% - 17vw);
        transition: opacity 2s;

        .bgd1 {
            width: 83%;
            height: 83%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd4.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd2 {
            width: 73%;
            height: 73%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd5.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example2;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd3 {
            width: 67%;
            height: 67%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd6.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd4 {
            width: 55%;
            height: 55%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd7.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example2;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd5 {
            width: 50%;
            height: 50%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd8.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd6 {
            width: 42%;
            height: 42%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd9.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
        }
        .bgd7 {
            width: 30%;
            height: 30%;
            border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd12.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example2;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .bgd8 {
            width: 24%;
            height: 24%;
            // border-radius: 50%;
            // border: 1px solid #ccc;
            background: url("@/assets/img/loding-bgd11.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            animation-name: example;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
        .val {
            width: 142px;
            height: 60px;
            font-size: 54px;
            color: #00ffea;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            font-family: PangMenZhengDao;
            text-align: center;
            line-height: 60px;
        }
    }
    .content.active {
        opacity: 0;
    }
    // .content{
    //     width: 62.5vh;
    //     height: 62.5vh;
    //     background:url('@/assets/img/loding-bgd3.png') no-repeat;
    //     background-size: 100% 100%;
    //     position: absolute;
    //     top: calc(50% - 31.25vh);
    //     left: calc(50% - 31.25vh);
    // }
}
.cbgd {
    width: 100vw;
    height: 100vh;
    // background: url("@/assets/img/bgd1.png") no-repeat,
    // url("@/assets/img/bgd2.png") no-repeat;
    background: // url("@/assets/img/bgd1.gif") no-repeat,
        url("@/assets/img/bgd1.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    pointer-events: none;
    z-index: 2;
    .logo {
        width: 25px;
        height: 25px;
        background: url("@/assets/img/logo.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 2.4%;
        top: 4%;
    }
    .abc {
        width: 5.5vh;
        height: 5.5vh;
        border-radius: 50%;
        position: absolute;
        z-index: 2;
        bottom: 56px;
        left: 27px;
        background: url("@/assets/img/icon3.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .a {
            width: 100%;
            height: 100%;
            background: url("@/assets/img/icon2.png") no-repeat;
            background-size: 100% 100%;
            animation-name: example2;
            animation-duration: 4s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
    }
    .move1 {
        width: 14px;
        height: 3px;
        background: #00bbff;
        position: absolute;
        top: 19px;
        left: 670px;
        animation-name: yidong1;
        animation-duration: 7s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
    .move2 {
        width: 13px;
        height: 4px;
        background: #00bbff;
        position: absolute;
        bottom: 15px;
        left: 280px;
        animation-name: yidong2;
        animation-duration: 5s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
    .move3 {
        width: 13px;
        height: 4px;
        background: #00bbff;
        position: absolute;
        bottom: 15px;
        right: 800px;
        animation-name: yidong3;
        animation-duration: 5s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
}
iframe {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    z-index: 1;
}
.time {
    width: 7%;
    position: absolute;
    z-index: 2;
    right: 7%;
    top: 2.2%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: #fff;
    div:nth-child(1) {
        font-size: 24px;
        line-height: 24px;
        font-family: PangMenZhengDao;
        overflow: hidden;
    }
    div:nth-child(2) {
        line-height: 12px;
        font-size: 12px;
        overflow: hidden;
    }
}
.top-btn-box {
    width: 50%;
    height: 24.5px;
    position: absolute;
    z-index: 2;
    right: 16%;
    top: 3%;
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 12px;
    .text {
        width: 99px;
        height: 24.5px;
        background: url("@/assets/img/btn-bgd3.png") no-repeat;
        background-size: 100%;
        background-position: bottom;
        text-align: center;
        line-height: 24px;
    }
    .li {
        width: 162px;
        height: 24.5px;
        background: url("@/assets/img/btn-bgd1.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 24px;
        cursor: pointer;
    }
    .li.active {
        background: url("@/assets/img/btn-bgd2.png") no-repeat;
        background-size: 100% 100%;
        font-family: SourceHanSansCNBold;
    }
}
.left-btn-box {
    width: 90px;
    height: 47%;
    position: absolute;
    z-index: 2;
    top: 25%;
    left: 1%;
    display: flex;
    flex-direction: column;
    .li {
        flex: 1;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: url("@/assets/img/btn-bgd5.png") no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
        .btn.active {
            width: 80px;
            height: 80px;
            background: url("@/assets/img/btn-bgd4.png") no-repeat;
            background-size: 100% 100%;
            .cartoon {
                width: 100%;
                height: 100%;
                background: url("@/assets/img/btn-bgd4-cartoon.png") no-repeat;
                background-size: 100% 100%;
                animation-name: example2;
                animation-duration: 4s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
            }
            .name {
                position: absolute;
                font-family: SourceHanSansCNBold;
                color: #fff;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
        .btn.no {
            cursor: not-allowed;
        }
        .name {
            position: absolute;
            color: #7f9db9;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
.right-box {
    width: 300px;
    height: 72%;
    // background: url('@/assets/img/right-box.png') no-repeat;
    // background-size: 100% 100%;
    position: absolute;
    z-index: 2;
    right: -300px;
    bottom: 192px;
    overflow: hidden;
    opacity: 0;
    transition: transform 1s, opacity 1s;
    display: flex;
    flex-direction: column;
    .model1 {
        flex: 1;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        // display:none;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .btn-box {
            width: 100%;
            height: 19px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 7px;
            .btn {
                width: 139px;
                height: 100%;
                border: 1px solid #027eac;
                box-sizing: border-box;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                span {
                    display: inline-block;
                    font-size: 12px;
                    line-height: 11px;
                    transform: scale(0.91);
                }
            }
            .btn.active {
                background: #027eac;
            }
        }
        .info {
            width: 100%;
            height: 51px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .li {
                width: 140px;
                height: 100%;
                // background: red;
                display: flex;
                align-items: center;
                justify-content: space-around;
                .icon {
                    width: 50px;
                    height: 46px;
                    background: url("@/assets/img/icon1.png") no-repeat;
                    background-size: 100% 100%;
                }
                .val-box {
                    width: 72px;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: end;
                    .val {
                        width: 100%;
                        height: 23.5px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .a {
                            width: 15px;
                            height: 100%;
                            background: linear-gradient(
                                #00bbff4f,
                                #00bbff4f,
                                #00bbff4f,
                                #00bbff00,
                                #00bbff4f,
                                #00bbff4f,
                                #00bbff4f
                            );
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            span {
                                background-image: -webkit-linear-gradient(
                                    top,
                                    #fff,
                                    #038cfd
                                );

                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                                font-size: 18px;
                                font-family: SourceHanSansCNBold;
                            }
                        }
                    }
                    .line {
                        width: 100%;
                        height: 2px;
                        margin-top: 1px;
                        background: url("@/assets/img/line.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .name {
                        color: #fff;
                        font-size: 12px;
                    }
                }
            }
        }
        .tab {
            width: 100%;
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            // background: red;
            .tab-title {
                width: 100%;
                height: 21px;
                background: url("@/assets/img/line2.png") no-repeat;
                background-size: 100%;
                background-position: bottom;
                font-size: 12px;
                display: flex;
                align-items: center;
                color: #fff;
            }
            .tab-content {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                color: #fff;

                .thead {
                    display: flex;
                    height: 20px;
                    justify-content: space-around;
                    align-items: center;
                    background: #027fac77;
                    // .th {
                    //     display: flex;
                    //     justify-content: center;
                    //     align-items: center;
                    // }
                    span {
                        font-size: 12px;
                        transform: scale(0.9);
                        position: relative;
                        top: -2px;
                    }
                }
                .tbody {
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    overflow: auto;
                    .tr {
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                    }
                    span {
                        font-size: 12px;
                        transform: scale(0.8);
                        position: relative;
                        top: -2px;
                    }
                    .tr:hover{
                        background: #019fd888;
                    }
                }
                .tbody::-webkit-scrollbar {
                    display: none;
                }
                .th,
                .td {
                    width: 100px;
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }
    .model2 {
        flex: 0.6;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        //  display:none;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .tab {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            color: #fff;
            padding: 4px 0px;

            .thead {
                display: flex;
                justify-content: space-around;
                align-items: center;
                background: url("@/assets/img/line3.png") no-repeat;
                background-size: 100% 100%;
                span {
                    font-size: 12px;
                    transform: scale(0.9);
                    position: relative;
                    top: -2px;
                }
                // .th {
                //     display: flex;
                //     justify-content: center;
                //     align-items: center;
                // }
            }
            .tbody {
                display: flex;
                flex-direction: column;
                overflow: auto;
                span {
                    font-size: 12px;
                    transform: scale(0.8);
                    position: relative;
                    top: -2px;
                }
                .tr {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                }
                .tr:hover {
                    background: #019fd888;
                }
            }
            .tbody::-webkit-scrollbar {
                display: none;
            }
            .th1,
            .td1 {
                width: 100px;
                height: 20px;
                // background: red;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .th2,
            .td2 {
                width: 100px;
                height: 20px;
                // background: red;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .th3,
            .td3 {
                width: 100px;
                height: 20px;
                // background: red;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .model3 {
        flex: 0.7;
        width: 100%;
        display: flex;
        flex-direction: column;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .content {
            flex: 1;
            width: 100%;
            padding: 3px 0px;
            display: flex;
            flex-direction: column;
            .btn-box {
                width: 100%;
                height: 20px;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                .btn {
                    width: 75px;
                    height: 18px;
                    background: #03a8ef71;
                    border: 1px solid #00bbff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 12px;
                    color: #fff;
                    cursor: pointer;
                }
                .btn.active {
                    background: #00bbff;
                }
            }
            .echarts-box {
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
            }
        }
    }
    .model4 {
        flex: 0.8;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .content {
            flex: 1;
            width: 100%;
            display: flex;
            .btn-box {
                width: 80px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                color: #fff;
                .a {
                    width: 38px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    span {
                        display: inline-block;
                        transform: rotate(90deg);
                    }
                }
                .name {
                    width: 38px;
                    height: 24px;
                    text-align: center;
                    line-height: 25px;
                    font-size: 12px;
                    background: #00000000;
                    border-bottom: 3px solid #00bbff00;
                    box-sizing: border-box;
                    cursor: pointer;
                }
                .name.active {
                    background: #083347;
                    border-bottom: 3px solid #00bbff;
                    box-sizing: border-box;
                }
                .b {
                    width: 38px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    span {
                        display: inline-block;
                        transform: rotate(90deg);
                    }
                }
            }
            .echarts-box {
                width: 220px;
                // height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
    }
}
.right-box.active {
    transform: translate(-327px, 0);
    opacity: 1;
}
.bottom-box {
    width: 92%;
    height: 175px;
    position: absolute;
    z-index: 2;
    right: 27px;
    // bottom: 19px;
    bottom: -175px;
    // background: red;
    opacity: 0;
    transition: transform 1s, opacity 1s;
    // background: url("@/assets/img/bottom-box.png") no-repeat;
    // background-size: 100% 100%;
    display: flex;
    .model1 {
        flex: 0.9;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .content {
            flex: 1;
            width: 100%;
            table {
                width: 100%;
                color: #fff;
                font-size: 12px;

                tr {
                    height: 30px;
                    span {
                        display: inline-block;
                        transform: scale(0.8);
                    }
                    td {
                        width: 9.1%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border: 1px solid #fdfdfd2f;
                    }
                }
                .tr1 {
                    height: 25px;
                    background: url("@/assets/img/line4.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

    .model2 {
        flex: 0.5;
        display: flex;
        margin: 0px 10px;
        flex-direction: column;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .btn-box {
                flex: 1;
                height: 100%;
                display: flex;
                position: absolute;
                right: 0;
                .btn {
                    width: 40px;
                    height: 100%;
                    text-align: center;
                    line-height: 25px;
                    cursor: pointer;
                }
                .btn.active {
                    background: linear-gradient(to bottom, #27c5ff, #fff);
                }
            }
        }
        .content {
            flex: 1;
            padding: 4px 0px;
            display: flex;
            flex-direction: column;
            color: #fff;
            font-size: 12px;
            .btn-box {
                width: 100%;
                height: 18px;
                display: flex;
                justify-content: space-between;
                .btn {
                    width: 48%;
                    height: 100%;
                    border: 1px solid #00bbff;
                    background: #00bbff50;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
                .btn.active {
                    background: #00bbff;
                }
            }
            .info-box {
                flex: 1;
                width: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                margin-top: 5px;
                .box {
                    flex: 1;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin: 4px 0px;
                    .info {
                        width: calc(48% + 1px);
                        height: 100%;
                        background: url("@/assets/img/border.png") no-repeat;
                        background-size: 100% 100%;
                        display: flex;
                        .icon {
                            width: 60px;
                            height: 100%;
                        }
                        .icon1 {
                            background: url("@/assets/img/icon5.png") no-repeat;
                            background-size: 40px 40px;
                            background-position: center;
                        }
                        .icon2 {
                            background: url("@/assets/img/icon6.png") no-repeat;
                            background-size: 40px 40px;
                            background-position: center;
                        }
                        .icon3 {
                            background: url("@/assets/img/icon7.png") no-repeat;
                            background-size: 40px 40px;
                            background-position: center;
                        }
                        .icon4 {
                            background: url("@/assets/img/icon8.png") no-repeat;
                            background-size: 40px 40px;
                            background-position: center;
                        }
                        .val-box {
                            flex: 1;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            transform: scale(0.8);
                            position: relative;
                            top: -3px;
                            .val {
                                span:nth-child(1) {
                                    color: #019ad3;
                                    font-size: 23px;
                                    font-weight: 700;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .model3 {
        flex: 0.5;

        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                // transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .content {
            flex: 1;
            display: flex;
            .icon {
                width: 142px;
                height: 150px;
                background: url("@/assets/img/icon4.png") no-repeat;
                background-size: 100% 100%;
                margin: 0px 10px;
            }
            .info {
                flex: 1;
                height: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                margin-left: 10px;
                .li {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #fff;

                    .a {
                        width: 7px;
                        height: 7px;
                        // margin-right: 4px;
                    }
                    .a1 {
                        background: #fff;
                    }
                    .a2 {
                        background: #00bbff;
                    }
                    .a3 {
                        background: #00ffea;
                    }
                    .a4 {
                        background: #ffc000;
                    }
                    .name {
                        transform: scale(0.85);
                    }
                    .val {
                        transform: scale(0.85);
                        transform-origin: left center;
                    }
                }
            }
        }
    }
    .model4 {
        flex: 0.5;
        margin: 0px 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .echarts-box {
            flex: 1;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
    .model5 {
        flex: 0.5;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title-box {
            width: 100%;
            height: 25px;
            background: #00bbff;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding-left: 10px;
            box-sizing: border-box;
            position: relative;
            .a {
                font-weight: 700;
            }
            .b {
                margin: 0px 5px;
            }
            .c {
                font-size: 12px;
                transform: scale(0.85);
                position: relative;
                left: -5px;
            }
            .d {
                width: 70px;
                height: 100%;
                background: linear-gradient(to bottom, #27c5ff, #fff);
                position: absolute;
                right: 0;
                text-align: center;
                line-height: 25px;
            }
        }
        .content {
            flex: 1;
            width: 100%;
            padding-top: 5px;
            overflow: hidden;
            .tab {
                width: 100%;
                height: 100%;
                color: #fff;
                font-size: 12px;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                .thead {
                    width: 100%;
                    height: 25px;
                    background: url("@/assets/img/line4.png") no-repeat;
                    background-size: 100% 100%;
                    display: flex;
                    .th {
                        width: 25%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span {
                            display: inline-block;
                            transform: scale(0.9) translate(0px, -2px)
                        }
                    }
                }
                .tbody {
                    flex: 1;
                    overflow: auto;
                    .tr {
                        height: 25px;
                        display: flex;
                        .td {
                            width: 25%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            span {
                                display: inline-block;
                                transform: scale(0.8);
                            }
                        }
                        
                    }
                    .tr:hover{
                        background: #019fd888;
                    }
                }
                .tbody::-webkit-scrollbar {
                    display: none;
                }
            }

            table {
                tr {
                    height: 26px;
                    span {
                    }
                    td {
                        width: 25%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                thead {
                    height: 25px;
                }
                tbody {
                    overflow: auto;
                }
            }
        }
    }
}
.bottom-box.active {
    transform: translate(0, -194px);
    opacity: 1;
}
</style>